export default __webpack_public_path__ + "static/media/over-axlesGroup.aa170aaf.svg";